module.exports = __webpack_public_path__ + "static/img/banner1.ad9f1ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1.png
// module id = 1MxG
// module chunks = 1